import { getBoulders } from './desertState.js';

export function drawRockFormations(ctx, time) {
  ctx.save();
  
  const boulders = getBoulders();
  
  boulders.forEach((rock, index) => {
    if (rock.mined) return;
    
    const shimmer = Math.sin(time * 1.8 + index) * 0.08 + 0.92;
    
    // Rock shadow
    ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
    ctx.beginPath();
    ctx.ellipse(rock.x + 4, rock.y + rock.height, rock.width * 0.7, rock.height * 0.25, 0, 0, Math.PI * 2);
    ctx.fill();
    
    // Main rock body with realistic shape
    const gradient = ctx.createRadialGradient(
      rock.x - rock.width * 0.25, rock.y - rock.height * 0.3, 0,
      rock.x, rock.y, Math.max(rock.width, rock.height)
    );
    gradient.addColorStop(0, `hsl(${rock.hue}, 45%, ${65 * shimmer}%)`);
    gradient.addColorStop(0.4, `hsl(${rock.hue + 8}, 40%, ${48 * shimmer}%)`);
    gradient.addColorStop(0.8, `hsl(${rock.hue + 15}, 35%, ${32 * shimmer}%)`);
    gradient.addColorStop(1, `hsl(${rock.hue + 20}, 30%, ${22 * shimmer}%)`);
    
    ctx.fillStyle = gradient;
    
    // Draw different rock shapes based on type
    ctx.beginPath();
    if (rock.rockType === 0) {
      // Irregular boulder
      ctx.ellipse(rock.x, rock.y, rock.width, rock.height, 0, 0, Math.PI * 2);
    } else if (rock.rockType === 1) {
      // Angular rock
      ctx.moveTo(rock.x - rock.width, rock.y);
      ctx.lineTo(rock.x - rock.width * 0.3, rock.y - rock.height);
      ctx.lineTo(rock.x + rock.width * 0.7, rock.y - rock.height * 0.8);
      ctx.lineTo(rock.x + rock.width, rock.y + rock.height * 0.2);
      ctx.lineTo(rock.x + rock.width * 0.2, rock.y + rock.height);
      ctx.lineTo(rock.x - rock.width * 0.8, rock.y + rock.height * 0.6);
      ctx.closePath();
    } else {
      // Layered rock
      ctx.ellipse(rock.x, rock.y, rock.width, rock.height * 0.8, 0, 0, Math.PI * 2);
    }
    ctx.fill();
    
    // Rock surface details and cracks
    rock.cracks.forEach(crack => {
      const startX = rock.x - rock.width + crack.startX * rock.width * 2;
      const startY = rock.y - rock.height + crack.startY * rock.height * 2;
      const endX = rock.x - rock.width + crack.endX * rock.width * 2;
      const endY = rock.y - rock.height + crack.endY * rock.height * 2;
      
      ctx.strokeStyle = `hsl(${rock.hue + 25}, 25%, 18%)`;
      ctx.lineWidth = crack.width;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.lineTo(endX, endY);
      ctx.stroke();
    });
    
    // Rock highlights
    ctx.fillStyle = `hsla(${rock.hue - 5}, 35%, 78%, 0.7)`;
    ctx.beginPath();
    ctx.arc(rock.x - rock.width * 0.3, rock.y - rock.height * 0.4, rock.width * 0.25, 0, Math.PI * 2);
    ctx.fill();
    
    // Smaller highlight
    ctx.fillStyle = `hsla(${rock.hue - 10}, 30%, 85%, 0.5)`;
    ctx.beginPath();
    ctx.arc(rock.x - rock.width * 0.15, rock.y - rock.height * 0.6, rock.width * 0.12, 0, Math.PI * 2);
    ctx.fill();
  });
  
  ctx.restore();
}